<div class="container">
    @if(isLoading) {
    <mat-spinner class="loading-spinner" [diameter]="70"></mat-spinner>
    } @else {
    <div class="generic-container" *ngIf="order">
        <mat-card class="content">
            <mat-card-content>
                <mat-card-header>
                    <p class="order-id">{{ "order.orderDetails.orderId" | translate }} : #{{ order.id }}</p>
                </mat-card-header>
                <div class="btn-group">
                    <div class="btn-content" *ngFor="let status of statusArray">
                        <span class="status-label">{{ status.label }}</span>
                        <button
                            mat-fab
                            (click)="
                                status.label === OrderStatus.Dispatched
                                    ? showDialogBoxCourierInfo(status.status)
                                    : updateStatus(order.id, status.status, '', '')
                            "
                            [ngClass]="getButtonColor(statusArray, status.status)"
                            [disabled]="
                                getButtonColor(statusArray, status.status) === 'green' ||
                                order.orderStatus === OrderStatus.Cancelled ||
                                order.orderStatus === OrderStatus.ReturnInitiated ||
                                isReturnStatus(order) ||
                                isExchangeStatus(order) ||
                                getButtonColor(statusArray, status.status) === 'grey'
                            "
                        >
                            <mat-icon>{{ status.icon }}</mat-icon>
                        </button>
                        <p>
                            {{ getStatusDate(status.status) }}
                        </p>
                        <div *ngIf="status.status === OrderStatus.Dispatched && hasBeenDispatched()">
                            <p class="awb-number">
                                <strong>{{ "order.orderDetails.awbNumber" | translate }} : </strong>
                                <span class="text-color">{{ order.awbNumber }}</span>
                            </p>
                            <p class="courier-name">
                                <strong>{{ "order.orderDetails.courierName" | translate }} : </strong
                                ><span class="text-color">{{ order.courierName }}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>

        <mat-card class="content" *ngIf="showExchangeProcess(order) || isExchangeStatus(order)">
            <mat-card-content>
                <mat-card-header>
                    <p class="order-id">{{ "order.statusHeading.exchangeOrderStatus" | translate }} :</p>
                </mat-card-header>
                <div class="btn-group">
                    <div class="btn-content" *ngFor="let exchangeStatus of exchangeOrderStatusArray">
                        <span class="status-label">{{ exchangeStatus.label }}</span>
                        <button
                            mat-fab
                            (click)="
                                exchangeStatus.label === OrderStatus.ExchangeDispatched
                                    ? showDialogBoxCourierInfo(exchangeStatus.status)
                                    : updateStatus(order.id, '', '', exchangeStatus.status)
                            "
                            [ngClass]="getButtonColorExchange(exchangeOrderStatusArray, exchangeStatus.status)"
                            [disabled]="
                                getButtonColorExchange(exchangeOrderStatusArray, exchangeStatus.status) === 'green' ||
                                getButtonColorExchange(exchangeOrderStatusArray, exchangeStatus.status) === 'grey'
                            "
                        >
                            <mat-icon>{{ exchangeStatus.icon }}</mat-icon>
                        </button>
                        <p>
                            {{ getStatusDate(exchangeStatus.status) }}
                        </p>
                        <div
                            *ngIf="
                                exchangeStatus.status === OrderStatus.ExchangeDispatched && hasBeenExchangeDispatched()
                            "
                        >
                            <p class="awb-number">
                                <strong>{{ "order.orderDetails.awbNumber" | translate }} :</strong>
                                <span class="text-color">{{ getExchangeAwbNumber(order) }}</span>
                            </p>
                            <p class="courier-name">
                                <strong>{{ "order.orderDetails.courierName" | translate }} : </strong
                                ><span class="text-color">{{ getExchangeCourierName(order) }}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>

        <mat-card class="content" *ngIf="showReturnProcess(order) || isReturnStatus(order)">
            <mat-card-content>
                <mat-card-header>
                    <p class="order-id">{{ "order.statusHeading.returnOrderStatus" | translate }}:</p>
                </mat-card-header>
                <div class="btn-group">
                    <div class="btn-content" *ngFor="let returnStatus of returnOrderStatusArray">
                        <span class="status-label">{{ returnStatus.label }}</span>
                        <button
                            mat-fab
                            (click)="
                                returnStatus.label === OrderStatus.PickupScheduled
                                    ? showDialogBoxPickupScheduled()
                                    : returnStatus.label === refundStatus.RefundInitiated
                                    ? openDialogRefundInitiated()
                                    : updateStatus(order.id, '', returnStatus.status, '')
                            "
                            [ngClass]="getButtonColorReturn(returnOrderStatusArray, returnStatus.status)"
                            [disabled]="
                                getButtonColorReturn(returnOrderStatusArray, returnStatus.status) === 'green' ||
                                getButtonColorReturn(returnOrderStatusArray, returnStatus.status) === 'grey'
                            "
                        >
                            <mat-icon>{{ returnStatus.icon }}</mat-icon>
                        </button>
                        <p>
                            {{ getStatusDate(returnStatus.status) }}
                        </p>
                        <div *ngIf="returnStatus.status === refundStatus.RefundInitiated && isRefundInitiated()">
                            <p class="awb-number">
                                <strong>{{ "order.orderDetails.utrNumber" | translate }} : </strong>
                                <span class="text-color">{{ getUtrNumber() }}</span>
                            </p>
                        </div>
                        <div
                            class="pickup-scheduled"
                            *ngIf="returnStatus.status === OrderStatus.PickupScheduled && ispickupSchedule()"
                        >
                            <p>
                                <strong>{{ "order.orderDetails.pickupDate" | translate }} : </strong>
                                <span class="text-color">{{ pickupScheduleDate }}</span>
                            </p>
                            <p>
                                <strong>{{ "order.orderDetails.pickupTime" | translate }} : </strong
                                ><span class="text-color">{{ order.pickupTime }}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>

        <div class="customer-info">
            <mat-card class="content">
                <mat-card-content>
                    <div class="customer-info-content">
                        <div class="left">
                            <h3>{{ "order.orderDetails.orderDetails" | translate }} :</h3>
                            <p>
                                {{ "order.orderDetails.name" | translate }} :
                                {{ order.orderAddress?.shippingAddress?.name }}
                            </p>
                            <p>
                                {{ "order.orderDetails.phoneNo" | translate }} :
                                {{ order.orderAddress?.shippingAddress?.mobileNumber }}
                            </p>
                            <p>{{ "order.orderDetails.email" | translate }} : {{ order.customerEmail }}</p>
                            <p>
                                {{ "order.orderDetails.address" | translate }} :
                                {{ order.orderAddress?.shippingAddress?.address }},
                                {{ order.orderAddress?.shippingAddress?.houseNumber }},
                                {{ order.orderAddress?.shippingAddress?.city }},
                                {{ order.orderAddress?.shippingAddress?.state }},{{
                                    order.orderAddress?.shippingAddress?.pincode
                                }}
                            </p>
                        </div>
                        <div class="mid" *ngIf="order.refundOption">
                            <h3>{{ "order.orderDetails.bankDetails" | translate }}</h3>
                            <p *ngIf="order.accountHolderName">
                                {{ "order.orderDetails.accountHolderName" | translate }} :
                                <span class="bank-details">{{ order.accountHolderName }}</span>
                            </p>
                            <p *ngIf="order.accountNumber">
                                {{ "order.orderDetails.accountNo" | translate }} :
                                <span class="bank-details">{{ order.accountNumber }}</span>
                            </p>
                            <p *ngIf="order.ifscCode">
                                {{ "order.orderDetails.ifscCode" | translate }} :
                                <span class="bank-details">{{ order.ifscCode }}</span>
                            </p>
                            <p *ngIf="order.upiId">
                                {{ "order.orderDetails.upiId" | translate }} :
                                <span class="bank-details">{{ order.upiId }}</span>
                            </p>
                            <p *ngIf="getRefundAmount()">
                                {{ "order.orderDetails.refundAmount" | translate }} :
                                <span class="bank-details">
                                    {{ "order.currency.rs" | translate }} {{ getRefundAmount() }}</span
                                >
                            </p>
                        </div>
                        <div>
                            <h3>{{ "order.orderDetails.status" | translate }} :</h3>
                            <p>
                                {{ "order.orderDetails.payment" | translate }} :
                                <span
                                    [ngClass]="{
                                        success: order.paymentStatus === paymentStatus.Success,
                                        pending: order.paymentStatus === paymentStatus.Pending,
                                        fail: order.paymentStatus === paymentStatus.Failed
                                    }"
                                    >{{ order.paymentStatus }}</span
                                >
                            </p>
                            <p *ngIf="this.isAllRefundSuccessful">
                                {{ "order.orderDetails.refundStatus" | translate }} :<span class="refund-successful">{{
                                    refundStatusMessage
                                }}</span>
                            </p>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>

        <div *ngFor="let item of this.order.orderItems">
            <mat-card class="content">
                <mat-card-content class="whole">
                    <div class="product-info">
                        <div>
                            @if (item.structure) {
                            <img [src]="item.structure.imageurl" alt="Item Image" />
                            } @else {
                            <img [src]="item.product?.images?.imagesUrl?.[0]" alt="Item Image" />
                            }
                        </div>
                        <div>
                            <p>
                                {{ "order.orderDetails.productName" | translate }} :
                                {{ item.product?.name || item.structure?.structureName }}
                            </p>
                            <p>{{ "order.orderDetails.quantity" | translate }}: {{ item.quantity }}</p>
                            <p>
                                {{ "order.orderDetails.price" | translate }}: {{ "order.currency.rs" | translate }}
                                {{ item.discountedPrice || item.price }}
                            </p>
                        </div>
                        <!-- Block Configuration -->
                        <div class="block-item-info-container" *ngIf="item.singleBlockInfoDirectBuy">
                            <!-- Node / Hole Configuration -->
                            <div class="node-hole-plane-config">
                                <div *ngIf="getFacesByType(item, 'Plane').length > 0" class="plane-config">
                                    <span class="block-face-label">{{ "order.orderDetails.plane" | translate }}: </span>
                                    <span class="block-face-value">{{ getFacesByType(item, "Plane") }}</span>
                                </div>

                                <div *ngIf="getFacesByType(item, 'Hole').length > 0" class="hole-config">
                                    <span class="block-face-label">{{ "order.orderDetails.hole" | translate }}: </span>
                                    <span class="block-face-value">{{ getFacesByType(item, "Hole") }}</span>
                                </div>

                                <div *ngIf="getFacesByType(item, 'Node').length > 0" class="node-config">
                                    <span class="block-face-label">{{ "order.orderDetails.node" | translate }}: </span>
                                    <span class="block-face-value">{{ getFacesByType(item, "Node") }}</span>
                                </div>
                            </div>
                            <!-- END -->

                            <!-- Color Configuration -->
                            <div class="color-config">
                                <p class="color-title">Color configuration</p>
                                <div class="color-info">
                                    <div *ngFor="let color of getFaceColors(item.singleBlockInfoDirectBuy?.color)">
                                        <div class="color-item">
                                            <div
                                                class="color-box"
                                                [ngStyle]="{ 'background-color': getColorValue(color.value) }"
                                            ></div>
                                            <div class="color-name">
                                                <span class="block-face-label">{{ color.key }} </span>
                                                <span class="block-face-value">
                                                    {{ color.value }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- END -->
                            <br />
                        </div>
                        <!-- END -->
                    </div>
                    <div>
                        <div class="refund-status" *ngIf="item.refund?.refundStatus">
                            <p>
                                {{ "order.orderDetails.refundStatus" | translate }}:
                                <span [ngClass]="getRefundStatusClass(item.refund?.refundStatus)">{{
                                    item.refund?.refundStatus
                                }}</span>
                            </p>
                        </div>

                        <div class="refund-status" *ngIf="item.itemStatus">
                            <p>
                                {{ "order.orderDetails.orderStatus" | translate }}:
                                <span [ngClass]="getOrderStatusClasses(item)">{{ item.itemStatus }}</span>
                            </p>
                        </div>
                    </div>
                </mat-card-content>
                <hr />
            </mat-card>
        </div>

        <div>
            <mat-card class="content">
                <mat-card-content>
                    <p class="order-info">
                        <strong>{{ "order.orderDetails.subTotal" | translate }} : </strong>
                        <span
                            >{{ "order.currency.rs" | translate }}
                            {{ isOrderFullyCancelledOrReturned ? order.originalSubTotal : order.currentSubTotal }}</span
                        >
                    </p>
                    <p class="order-info">
                        <strong>{{ "order.orderDetails.couponDiscount" | translate }} : </strong>
                        <span
                            >- {{ "order.currency.rs" | translate }}
                            {{
                                isOrderFullyCancelledOrReturned
                                    ? order.originalCouponDiscount
                                    : order.currentCouponDiscount
                            }}</span
                        >
                    </p>
                    <p class="order-info">
                        <strong>{{ "order.orderDetails.shipping" | translate }} : </strong>
                        <span>+ {{ "order.currency.rs" | translate }} {{ order.deliveryCharge }}</span>
                    </p>
                    <p class="order-info">
                        <strong>{{ "order.orderDetails.total" | translate }} : </strong>
                        <span
                            >{{ "order.currency.rs" | translate }}
                            {{ isOrderFullyCancelledOrReturned ? order.originalTotal : order.currentTotal }}</span
                        >
                    </p>
                    <p class="order-info">
                        <strong>{{ "order.orderDetails.coinsUsed" | translate }} : </strong>
                        <span
                            >{{ "order.currency.rs" | translate }}
                            {{
                                isOrderFullyCancelledOrReturned ? order.originalCoinsUsed : order.currentCoinsUsed
                            }}</span
                        >
                    </p>
                    <p class="order-info">
                        <strong
                            >{{
                                (order.paymentMethod === PaymentMethod.CashOnDelivery &&
                                (order.orderStatus === OrderStatus.Ordered ||
                                    order.orderStatus === OrderStatus.Packed ||
                                    order.orderStatus === OrderStatus.Dispatched ||
                                    order.orderStatus === OrderStatus.Cancelled)
                                    ? "order.orderDetails.payableAmount"
                                    : "order.orderDetails.amountCharged"
                                ) | translate
                            }}
                            :
                        </strong>
                        <span
                            >{{ "order.currency.rs" | translate }}
                            {{
                                isOrderFullyCancelledOrReturned
                                    ? order.originalPaymentAmount
                                    : order.currentPaymentAmount
                            }}</span
                        >
                    </p>
                    <p class="order-info refund-amount" *ngIf="refundStatusMessage === refundStatus.RefundSuccessful">
                        <span class="refund-successful">Refunded Amount:</span>
                        <span class="refund-successful">Rs. {{ refundAmount }} </span>
                    </p>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    }
</div>
